import { useCallback } from 'react';
import { QueryResult, useLazyQuery } from '@apollo/client';
import searchCar from '../../graphql/queries/searchCar';
import { GetSearchCar, GetSearchCarVariables } from '../../graphql/queries/__generated__/GetSearchCar';
import useCollectedFilters from '../../../trimLevels/hooks/useCollectedFilters';

const useSearchCar = () => {
  const { filters } = useCollectedFilters();

  const [query, { data, loading, error }] = useLazyQuery<GetSearchCar, GetSearchCarVariables>(searchCar.SEARCH_CAR, {
    variables: {
      filters,
    },
  });

  const loadSearchCar = useCallback(
    (callback?: (result?: QueryResult<GetSearchCar, GetSearchCarVariables>) => void) => {
      const abortController = new window.AbortController();
      query({
        variables: {
          filters,
        },
        context: {
          fetchOptions: {
            signal: abortController.signal,
          },
        },
      }).then(result => callback && callback(result));

      return () => abortController.abort();
    },
    [filters, query],
  );

  return { data: data, loading, error, loadSearchCar };
};

export default useSearchCar;
